import { WRMResourceRecorder } from '../src/WRMResourceRecorder.ts';

export const wrmResourceRecorder = new WRMResourceRecorder();
